<template>
  <div>
    <div class="enrollment-forms">
      <img class="background-circles_right" src="@Shared/assets/images/circles-right-form.svg"
        alt="Background shapes" />
      <img class="background-circle_left" src="@Shared/assets/images/small-green-semi-circle.svg"
        alt="Background shapes" />
      <div class="vcore_container pe_container enrollment-forms_card_wrapper">
        <div class="vcore_row">
          <div class="vcore_col--xs--12">
            <ProgressBar :steps="stepNames.slice(0, stepNames.length - 1)" :activeStep="activeStep" class="progress-bar"
              :hasError="hasMajorError" />
            <div class="content">
              <div class="vcore_col--xs--12" v-if="currentErrors.length">
                <ErrorBox :errors="currentErrors" />
              </div>
              <transition name="fade" mode="out-in" @beforeLeave="beforeLeave" @enter="enter" @afterEnter="afterEnter">
                <keep-alive>
                  <FormError v-if="hasMajorError"></FormError>
                  <component v-else ref="currentPage" :is="activeForm" :currentStep="activeStep"
                    @next-step="handleNextStep" @prev-step="handlePrevStep" @save-step="handleEditReturn"
                    @edit-click="handleEditClick" @major-error="handleError" />
                </keep-alive>
              </transition>
            </div>
          </div>
        </div>
        <div v-if="activeForm === 'Confirmation' && !hasMajorError" class="vcore_row">
          <div v-if="termsAndConditionsError" class="vcore_col--xs--12">
            <div class="confirmation_error_wrapper">
              <img src="@Shared/assets/images/warning.svg" alt="warning" />
              <span>Error: You must accept the terms and conditions before
                submitting.</span>
            </div>
          </div>
          <div class="vcore_col--xs--12">
            <div class="consent-to-contact_wrapper">
              <label for="consent-to-contact-checkbox" id="consent-to-contact" class="vcore_checkbox-group">
                <div class="vcore_checkbox">
                  <input id="consent-to-contact-checkbox" type="checkbox" class="vcore_checkbox-input"
                    v-model="acceptedConsentToContact" />
                  <span class="vcore_checkbox-indicator"></span>
                </div>
                <span class="vcore_checkbox-label">
                  {{ consentVerbiage }}
                </span>
              </label>
            </div>
            <div class="terms-and-conditions_wrapper">
              <label for="terms-and-conditions-checkbox" id="terms-and-conditions" class="vcore_checkbox-group">
                <div class="vcore_checkbox">
                  <input id="terms-and-conditions-checkbox" type="checkbox" class="vcore_checkbox-input"
                    v-model="acceptedTermsAndConditions" />
                  <span class="vcore_checkbox-indicator"></span>
                </div>
                <span class="vcore_checkbox-label">
                  By clicking “Submit”, you certify that you understand that you
                  are enrolling in a credit program requiring repayment and that
                  all information you supplied is true and correct at the time
                  it was provided, and you agree that Commerce Bank will provide
                  this information to the Patient’s Healthcare Provider as part
                  of the enrollment process. You further confirm you have read
                  and agreed to all of the
                  <a class="vcore_link" target="_blank" :href="disclosureUrl" download="disclosurePdf">disclosures</a>
                  set forth in this application and will thoroughly review any
                  and all forthcoming terms and conditions of the product and
                  will keep the same for your records.
                </span>
              </label>
            </div>
          </div>
        </div>
        <div v-if="hasMajorError" class="vcore_row buttons">
          <div class="vcore_col--xs--12 vcore_col--md--3 vcore_col--lg--2">
            <Button id="enrollment-forms_error-btn" color="blue" :block="true" size="large"
              @click.native="handleErrorBtnClick">Go to Home</Button>
          </div>
        </div>
        <div class="vcore_row buttons" v-if="showButtons">
          <div class="vcore_col--xs--12 vcore_col--md--3 vcore_col--lg--2 vcore_push--md--9 vcore_push--lg--10">
            <Button id="enrollment-forms_next-btn" color="blue" :block="true" size="large"
              @click.native="handleContinueClick" :loading="requestStatus.formNextLoading.active"
              :disabled="disableSubmitButton">{{ nextButtonText }}</Button>
          </div>
          <div class="vcore_col--xs--12 vcore_col--md--3 vcore_col--lg--2 vcore_pull--md--3 vcore_pull--lg--2">
            <Button id="enrollment-forms_prev-btn" color="blue" size="large" :block="true"
              :disabled="requestStatus.formNextLoading.active" variant="secondary"
              @click.native="handleBackClick">Back</Button>
          </div>
        </div>
        <div class="vcore_row enrollment_disclosures_wrapper">
          <div v-if="stepNames[activeStep] === 'Confirmation' && !hasMajorError"
            class="enrollment_disclosures vcore_col--xs--12">
            IMPORTANT INFORMATION ABOUT PROCEDURES FOR OPENING A NEW ACCOUNT –
            To help the government fight the funding of terrorism and money
            laundering activities, federal law requires all financial
            institutions to obtain, verify, and record information that
            identifies each person who opens an account. What this means for
            you: When you open an account, we will ask for your name, address,
            date of birth, and other information that will allow us to identify
            you. We may also ask to see your driver’s license or other
            identifying documents.
          </div>
          <div v-if="!selectedProvider.isFixedRate &&
              !hasMajorError &&
              (stepNames[activeStep] === 'Financing Information' ||
                stepNames[activeStep] === 'Confirmation' ||
                stepNames[activeStep] === 'Success')
              " class="enrollment_disclosures vcore_col--xs--12">
            * APR accurate as {{ todaysDate }}. The Annual Percentage Rate (APR)
            may vary monthly if the Prime Rate changes. The Prime Rate used to
            determine the APR on this Account is the U.S. Prime Rate published
            in The Wall Street Journal in its column called "Money Rates" on the
            last business day of each month.
          </div>
          <div v-if="steps[activeStep].disclaimers.estimator && !hasMajorError"
            class="enrollment_disclosures vcore_col--xs--12">
            ** The information entered into the payment estimate calculator is
            intended for hypothetical purposes only and the results provided are
            wholly illustrative. Accuracy is not guaranteed. Your actual monthly
            payment amount will be provided to you after we receive your balance
            information from your health care provider but before you become
            obligated to pay, and on each billing statement thereafter.
          </div>
          <div v-if="(stepNames[activeStep] === 'Financing Information' ||
              stepNames[activeStep] === 'Confirmation' ||
              stepNames[activeStep] === 'FRP Information')" class="enrollment_disclosures vcore_col--xs--12">
            <br /> Enrolling in financing through Commerce Bank is optional and there
            may be other repayment options or financial assistance programs available to you.
            Contact your Provider for information on repayment options.
          </div>
        </div>
      </div>
    </div>
    <Feedback v-if="(stepNames[activeStep] === 'Success')"/>
    <EnrollmentFooter />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import Button from "@Shared/components/Button";
import EnrollmentFooter from "../components/Enrollment/EnrollmentFooter";
import ProgressBar from "@Shared/components/ProgressBar";
import FRPInformation from "../components/Forms/FRPInformation";
import FinancingInformation from "../components/Forms/FinancingInformation";
import ErrorBox from "@Shared/components/ErrorBox";
import Confirmation from "../components/Forms/Confirmation";
import Success from "../components/Forms/Success";
import FormError from "../components/Forms/FormError";
import { scrollTop } from "@Shared/utils/Scroll";
import moment from "moment";
import API from "../constants.js";
import Feedback from "../components/Feedback/Feedback.vue";

const BASE_API_URL = API.patientEnrollment;

export default {
  name: "EnrollmentForms",
  components: {
    Button,
    EnrollmentFooter,
    ProgressBar,
    FRPInformation,
    FinancingInformation,
    ErrorBox,
    Confirmation,
    Success,
    FormError,
    Feedback,
  },
  data() {
    return {
      steps: [
        {
          name: "FRP Information",
          form: "FRPInformation",
          path: "frp-information",
          complete: false,
          disclaimers: {
            apr: false,
            estimator: false,
          },
        },
        {
          name: "Financing Information",
          form: "FinancingInformation",
          path: "financing-information",
          complete: false,
          disclaimers: {
            apr: true,
            estimator: true,
          },
          routeGuard: (to, from, next) => {
            if (this.steps[0].complete && this.activeErrors.length === 0) {
              next();
            } else {
              next(false);
            }
          },
        },
        {
          name: "Confirmation",
          form: "Confirmation",
          path: "confirmation",
          complete: false,
          disclaimers: {
            apr: true,
            estimator: true,
          },
          routeGuard: (to, from, next) => {
            if (this.steps[1].complete && this.activeErrors.length === 0) {
              next();
            } else {
              next(false);
            }
          },
        },
        {
          name: "Success",
          form: "Success",
          path: "success",
          complete: false,
          disclaimers: {
            apr: true,
            estimator: true,
          },
          routeGuard: (to, from, next) => {
            if (this.steps[2].complete && this.activeErrors.length === 0) {
              next();
            } else {
              next(false);
            }
          },
        },
      ],
      activeStep: 0,
      currentErrors: [],
      hasMajorError: false,

      disableSubmitButton: false,
      baseDisclosureUrl: `${BASE_API_URL}/Institution/GetDisclosure?SPID=`,
    };
  },
  computed: {
    ...mapGetters([
      "activeErrors",
      "termsAndConditionsError",
      "requestStatus",
      "selectedProvider",
      "featureFlags",
      "enrollmentCurrentStepIndex",
      "editFlag",
      "basicEditFlag",
      "formValues",
      "uneditedFormValues",
      "showFRPAdditionalInformation",
      "physicalMailingAddressCheckbox",
      "previousAddressCheckbox",
      "uneditedPhysicalMailingAddressCheckbox",
      "uneditedPreviousAddressCheckbox",
      //"existingHSFAccount",
      "uneditedexistingHSFAccount",
    ]),
    console: () => console,
    stepNames() {
      return this.steps.map((x) => x.name);
    },

    activeForm() {
      return this.steps[this.activeStep].form;
    },

    isLastStep() {
      return this.activeStep === this.steps.length - 1;
    },
    acceptedTermsAndConditions: {
      get() {
        return this.$store.state.acceptedTermsAndConditions;
      },
      set(status) {
        this.$store.dispatch("setTermsAndConditionsStatus", status);
      },
    },
    acceptedConsentToContact: {
      get() {
        return this.$store.state.consentToContact;
      },
      set(status) {
        this.$store.dispatch("setConsentToContact", status);
      },
    },
    nextButtonText() {
      if (this.stepNames[this.activeStep] === "Confirmation") {
        return "Submit";
      }
      if (this.editFlag) {
        return "Save Changes";
      }
      return "Continue";
    },
    showButtons() {
      if (this.hasMajorError) {
        return false;
      } else if (this.isLastStep) {
        return false;
      } else {
        return true;
      }
    },
    disclosureUrl() {
      if (this.selectedProvider.spid) {
        return `${this.baseDisclosureUrl}${this.selectedProvider.spid}`;
      }
      return "";
    },
    todaysDate() {
      return moment().format("MM/DD/YYYY");
    },

    /*existingHSFAccountLocal: {
      get() {          
        return this.existingHSFAccount;
      }  },*/

    uneditedexistingHSFAccountLocal: {
      get() {
        return this.uneditedexistingHSFAccount;
      },
    },
    consentVerbiage() {
      return this.selectedProvider.consentVerbiage;
    },
  },
  watch: {
    "$route.params.step": {
      handler(val) {
        let stepId = this.steps.findIndex((x) => x.path === val);

        if (stepId === -1) {
          stepId = 0;
        }

        if (this.activeStep !== stepId) {
          this.activeStep = stepId;
        }

        scrollTop(0, 300);
      },
    },
    activeStep: {
      handler(val) {
        if (val < 0 || val > this.steps.length) {
          this.activeStep = 0;
          return;
        }

        const step = this.steps[val].path;

        if (this.$route.params.step !== step) {
          this.$router.push({ params: { step: step } });
        }
      },
      immediate: true,
    },
    acceptedTermsAndConditions(newVal) {
      if (newVal) {
        this.setTermsAndConditionsError(false);
      }
    },
    consentToContact(newVal) {
      if (newVal) {
        this.setTermsAndConditionsError(false);
      }
    },
    hasMajorError(val) {
      if (val) {
        this.setCompleteForError("Error on next form");
      }
    },
  },
  methods: {
    ...mapActions([
      "createTimer",
      "resetErrors",
      "setTermsAndConditionsError",
      "setCompleteForError",
      "setPhysicalMailingAddressCheckbox",
      "setPreviousAddressCheckbox",
      "incrementEnrollmentCurrentStepIndex",
      "decrementEnrollmentCurrentStepIndex",
      "clearSession",
      "saveExistingHSFAccount",
      "setExistingHSFAccount",
    ]),
    saveEdits() {
      this.$store.commit(
        "SET_UNEDITED_FORM_VALUES",
        JSON.parse(JSON.stringify(this.formValues))
      );
      this.$store.commit(
        "SET_UNEDITED_PHYSICAL_MAILING_ADDRESS_CHECKBOX",
        this.physicalMailingAddressCheckbox
      );
      this.$store.commit(
        "SET_UNEDITED_PREVIOUS_ADDRESS_CHECKBOX",
        this.previousAddressCheckbox
      );
      //this.saveExistingHSFAccount(this.existingHSFAccountLocal);
    },
    handleNextStep() {
      this.steps[this.activeStep].complete = true;
      this.activeStep += 1;
    },
    handlePrevStep() {
      if (this.activeStep > 0) {
        this.activeStep -= 1;
      } else {
        this.$router.push({ name: "enroll" });
      }
    },
    handleEditReturn() {
      if (
        this.physicalMailingAddressCheckbox == true ||
        this.previousAddressCheckbox == true
      ) {
        this.$store.commit("SET_SHOW_FRP_ADDITIONAL_INFORMATION", true);
      }
      this.$store.commit("SET_EDIT_FLAG", false);
      this.$store.commit("SET_BASIC_EDIT_FLAG", false);
      this.activeStep = 2;
    },
    handleEditClick(location) {
      this.saveEdits();
      switch (location) {
        case "Account Information":
          this.activeStep = 1;
          break;
        case "Basic Information":
          if (this.showFRPAdditionalInformation) {
            this.$store.commit("SET_SHOW_FRP_ADDITIONAL_INFORMATION", false);
          }
          this.$store.commit("SET_BASIC_EDIT_FLAG", true);
          this.activeStep = 0;
          break;
        case "Physical Address":
          if (this.showFRPAdditionalInformation) {
            this.$store.commit("SET_SHOW_FRP_ADDITIONAL_INFORMATION", false);
          }
          this.$store.commit("SET_BASIC_EDIT_FLAG", true);
          this.activeStep = 0;
          break;
        case "Mailing Address":
          this.activeStep = 0;
          break;
        case "Previous Address":
          this.activeStep = 0;
          break;
        default:
          break;
      }
    },
    handleContinueClick() {
      // Call Touch to generate any errors of untouched fields
      this.$refs.currentPage.touch();

      // Run on next tick to allow for touch to finish setting everything.
      // TODO: Possibly move by moving vuelidate stuff to vuex
      this.$nextTick(() => {
        this.currentErrors = [...this.activeErrors];

        if (
          this.activeErrors.length === 0 &&
          !this.requestStatus.formNextLoading.active
        ) {
          this.resetErrors();

          if (this.editFlag) {
            if (
              this.activeStep == 0 &&
              this.showFRPAdditionalInformation == false
            ) {
              //Coming from basic info page
              // If user didn't add one of the checkboxes, save edits.
              if (
                !(
                  (this.physicalMailingAddressCheckbox == true &&
                    this.uneditedPhysicalMailingAddressCheckbox == false) ||
                  (this.previousAddressCheckbox == true &&
                    this.uneditedPreviousAddressCheckbox == false)
                )
              ) {
                this.saveEdits();
              }
              this.$refs.currentPage.next();
            } else {
              //Coming from additional page or account page
              this.saveEdits();
              this.$refs.currentPage.next();
            }
          } else {
            //if(this.activeStep == 1)
            //this.saveExistingHSFAccount(this.existingHSFAccountLocal);
            if (
              this.activeStep == 2 &&
              this.acceptedTermsAndConditions == true &&
              this.consentToContact
            ) {
              //when on submit step prevent double submissions
              this.disableSubmitButton = true;
            }
            this.$refs.currentPage.next();
          }
        }
      });
    },
    handleBackClick() {
      // Only clear session when leaving the FRP step for search, not when toggling
      // between FRP main and FRP additional information sub-views.
      const leavingToSearch =
        this.enrollmentCurrentStepIndex == 0 &&
        this.activeStep === 0 &&
        !this.showFRPAdditionalInformation;

      if (leavingToSearch) {
        this.clearSession();
      }

      if (this.editFlag) {
        if (
          this.basicEditFlag == true &&
          this.showFRPAdditionalInformation == true
        ) {
          this.$refs.currentPage.previous();
          this.$nextTick(() => {
            this.currentErrors = [...this.activeErrors];
          });
        } else {
          this.setPhysicalMailingAddressCheckbox(
            this.uneditedPhysicalMailingAddressCheckbox
          );
          this.setPreviousAddressCheckbox(this.uneditedPreviousAddressCheckbox);
          this.setExistingHSFAccount(this.uneditedexistingHSFAccountLocal); //change back to unedited value
          this.$store.commit(
            "SET_FORM_VALUES",
            JSON.parse(JSON.stringify(this.uneditedFormValues))
          ); // Cancel changes, so form values is overwritten with saved values
          this.$store.commit("SET_TERMS_AND_CONDITIONS_ERROR", false);

          this.handleEditReturn();
          this.$nextTick(() => {
            this.currentErrors = [...this.activeErrors];
          });
        }
      } else {
        this.$refs.currentPage.previous();
        this.$nextTick(() => {
          this.currentErrors = [...this.activeErrors];
        });
      }
    },
    handleError() {
      this.hasMajorError = true;
    },
    handleErrorBtnClick() {
      this.$router.replace({ name: "enroll" });
    },
    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height;
    },
    enter(element) {
      this.createTimer();
      const { height } = getComputedStyle(element);
      element.style.height = this.prevHeight;
      setTimeout(() => {
        element.style.height = height;
      });
    },
    afterEnter(element) {
      element.style.height = "auto";
    },
  },
  mounted() {
    this.createTimer();
    scrollTop(0, 300);
    this.$store.commit("SET_EDIT_FLAG", false);
    this.$store.commit("SET_FILE_METHOD_ERROR", false);
    //if back button pressed;
  },
  beforeRouteLeave(to, from, next) {
    this.$store.dispatch("decrementEnrollmentCurrentStepIndex");

    //only clear form and set session modal as hidden if if going back to search
    if (this.enrollmentCurrentStepIndex == 0) {
      this.$store.dispatch("clearSession");
    }

    next(true);
  },
  beforeRouteUpdate(to, from, next) {
    if (this.$store.state.submissionComplete && to.path !== "/search/success") {
      this.$store.dispatch("setFormValues", {});
      this.$store.dispatch("resetSelectedProvider");
      this.$store.dispatch("resetSearchedProviders");

      next({ name: "landing-page" });
    }

    const toIndex = this.steps.findIndex((x) => x.path === to.params.step);
    const fromIndex = this.steps.findIndex((x) => x.path === from.params.step);

    if (fromIndex > toIndex) {
      // Reset errors when going back a step
      this.$refs.currentPage.reset();
      this.$store.dispatch("decrementEnrollmentCurrentStepIndex");
      this.$nextTick(() => {
        this.currentErrors = [...this.activeErrors];
      });
    } else if (fromIndex < toIndex) {
      // Check errors when going forward
      this.$refs.currentPage.touch();
      this.$store.dispatch("incrementEnrollmentCurrentStepIndex");
      this.$nextTick(() => {
        this.currentErrors = [...this.activeErrors];
      });
    }

    const step = this.steps[toIndex];

    if (step && !!step.routeGuard) {
      step.routeGuard(to, from, next);
    } else if (step && !step.routeGuard) {
      next();
    } else {
      next(false);
    }
  },
};
</script>

<style lang="scss">
.enrollment-forms {
  padding-top: 25px;
  padding-bottom: 100px;

  @media (max-width: $grid-breakpoint-lg) {
    padding-bottom: 300px;
  }

  @media (max-width: $grid-breakpoint-sm) {
    background-color: $color_white;
    padding-top: 0;
  }
}

.enrollment-forms_card_wrapper.pe_container.vcore_container {
  @media (max-width: $grid-breakpoint-sm) {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}

.background-circles_right {
  position: absolute;
  top: 193px;
  right: 0;
}

.background-circle_left {
  position: absolute;
  top: 153px;
  left: 0;
  height: 125px;
}

.progress-bar {
  z-index: 1;
}

.content {
  border: 1px solid #d3d6de;
  border-top: 0;
  margin-top: -7.5px;
  padding: 40px 35px;
  background-color: #ffffff;
  box-shadow: 0 2px 14px 0 rgba(119, 151, 178, 0.23);
  z-index: -1;

  @media (max-width: $grid-breakpoint-sm) {
    padding: 30px 0 10px;
    border: none;
    box-shadow: none;
  }
}

.buttons {
  margin-top: 20px;

  @media (max-width: $grid-breakpoint-sm) {
    padding-left: 25px;
    padding-right: 25px;
  }

  #enrollment-forms_next-btn {}

  #enrollment-forms_prev-btn {
    @media (max-width: $grid-breakpoint-md) {
      margin-top: 20px;
    }
  }
}

.terms-and-conditions_wrapper {
  @media (max-width: $grid-breakpoint-sm) {
    padding-left: 25px;
    padding-right: 25px;
  }
}

.consent-to-contact_wrapper {
  @media (max-width: $grid-breakpoint-sm) {
    padding-left: 25px;
    padding-right: 25px;
  }
}

#terms-and-conditions {
  margin-top: 30px;

  .vcore_checkbox-label {
    font-size: 12px;
    line-height: 17px;
    font-weight: normal;
  }
}

#consent-to-contact {
  margin-top: 30px;

  .vcore_checkbox-label {
    font-size: 12px;
    line-height: 17px;
    font-weight: normal;
  }
}

.confirmation_error_wrapper {
  border: 1px solid #d3d6de;
  border-left: 5px solid $color_red;
  color: $color_red;
  padding: 13px 25px;
  background-color: $color_white;
  margin-top: 20px;
  font-size: 14px;

  img {
    height: 20px;
    margin-right: 7px;
    vertical-align: bottom;
  }
}

.enrollment_disclosures_wrapper {
  margin-top: 50px;
  margin-bottom: 75px;

  @media (max-width: $grid-breakpoint-sm) {
    margin-top: 75px;
  }

  @media (max-width: $grid-breakpoint-sm) {
    margin-top: 50px;
    padding-left: 25px;
    padding-right: 25px;
  }

  .enrollment_disclosures {
    font-size: 12px;
    line-height: 17px;
    color: $color_stephs-grey;

    &+.enrollment_disclosures {
      margin-top: 15px;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.5s;
  transition-property: height, opacity;
  transition-timing-function: ease;
  overflow: hidden;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.vcore_popover-content img {
  width: 100%;
}

@media all and (max-width: 320px) {
  #popover_ssn .vcore_popover {
    max-width: 310px !important;
    transform: translate3d(0px, -116px, 0px) !important;
  }

  #popover_ssn .vcore_popover.vcore_popover-top::before {
    left: 77.5% !important;
  }

  #popover_ssn .vcore_popover.vcore_popover-top::after {
    left: 77.5% !important;
  }
}

@media all and (max-width: 320px) {
  #popover-account-number.vcore_popover {
    max-width: 310px !important;
    transform: translate3d(0px, -116px, 0px) !important;
  }

  #popover-account-number.vcore_popover.vcore_popover-top::before {
    left: 77.5% !important;
  }

  #popover-account-number.vcore_popover.vcore_popover-top::after {
    left: 77.5% !important;
  }
}
</style>
